import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Flex, Stack, Text, Textarea } from '@chakra-ui/react';
import { useState } from 'react';
import { useAgentBlocksTextContext } from '../../text/agent-blocks-text-context';
import { ComposerPageChip } from './ComposerPageChip';
import { ComposerSendButton } from './ComposerSendButton';
export const COMPOSER_MAX_LENGTH = 2000;
/** The counter only shows once the limit is worth knowing about. */
export const COMPOSER_COUNTER_FROM = 1800;
/**
 * Where the brand asks. Enter sends, Shift+Enter breaks the line, the field
 * grows up to 160px (`sizes.40`) then scrolls. No attachment button: the agent has no use
 * for a file yet.
 */
export function Composer({ value, onValueChange, onSubmit, isAnswering = false, onStop, pageName, maxLength = COMPOSER_MAX_LENGTH, autoFocus = false, }) {
    const text = useAgentBlocksTextContext();
    const [ownValue, setOwnValue] = useState('');
    const current = value ?? ownValue;
    const question = current.trim();
    const canSend = question.length > 0 && !isAnswering;
    const change = (next) => {
        const capped = next.slice(0, maxLength);
        if (value === undefined)
            setOwnValue(capped);
        onValueChange?.(capped);
    };
    const submit = () => {
        if (!canSend)
            return;
        onSubmit(question);
        change('');
    };
    const onKeyDown = (event) => {
        if (event.key !== 'Enter' || event.shiftKey || event.nativeEvent.isComposing)
            return;
        event.preventDefault();
        submit();
    };
    return (_jsxs(Stack, { gap: "2", children: [_jsxs(Flex, { direction: "column", gap: "2", pt: "3", pe: "2.5", pb: "2.5", ps: "3.5", bg: "agent.surface", borderWidth: "1px", borderColor: "agent.border", borderRadius: "2xl", transitionProperty: "common", transitionDuration: "fast", _focusWithin: { borderColor: 'agent.focusRing' }, children: [pageName ? _jsx(ComposerPageChip, { name: pageName }) : null, _jsx(Textarea, { variant: "outline", "aria-label": text.composer.label, placeholder: text.composer.placeholder, value: current, onChange: (event) => change(event.target.value), onKeyDown: onKeyDown, maxLength: maxLength, autoFocus: autoFocus, rows: 1, autoresize: true, resize: "none", minH: "6", maxH: "40", overflowY: "auto", p: "0", borderWidth: "0", borderRadius: "0", bg: "transparent", fontSize: "sm", lineHeight: "1.55", color: "agent.fg", _placeholder: { color: 'agent.placeholder' }, focusVisibleRing: "none" }), _jsxs(Flex, { align: "center", gap: "1", children: [_jsx(Box, { flex: "1", minW: "0", children: current.length > COMPOSER_COUNTER_FROM ? (_jsx(Text, { textStyle: "agent.meta", color: current.length >= maxLength ? 'agent.danger.fg' : 'agent.fgMuted', fontVariantNumeric: "tabular-nums", children: text.composer.counter(current.length, maxLength) })) : null }), _jsx(ComposerSendButton, { canSend: canSend, isAnswering: isAnswering, onSend: submit, onStop: onStop })] })] }), _jsx(Text, { textAlign: "center", textStyle: "agent.meta", color: "agent.fgMuted", children: text.composer.footer })] }));
}
